/**
 * Link del mail de carrito abandonado con promo de retargeting:
 *   /evento/{hash}/step/1?promo=<token>
 *
 * El token lo arma ew-general-kernel-ms y lo desarma el BFF; acá viaja tal cual como
 * `hash`. Si es inválido, el BFF responde el error.
 */

export const RETARGETING_PROMO_PARAM = 'promo';

/** Devuelve el token de `?promo=` tal cual vino, o null si no está. */
export const getRetargetingPromoHash = (search: string = window.location.search): string | null => {
  const hash = new URLSearchParams(search).get(RETARGETING_PROMO_PARAM)?.trim();
  return hash ? hash : null;
};

/** Saca `promo` de la url sin recargar, para que un refresh no vuelva a disparar el flujo. */
export const removeRetargetingPromoParam = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(RETARGETING_PROMO_PARAM)) {
    return;
  }
  url.searchParams.delete(RETARGETING_PROMO_PARAM);
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
};
